import {
  createQuery,
  createSuspenseQuery
} from "../../utils/queryFactories.js";
import { api } from "../../utils/fetch.js";
import { z } from "zod";

const getFileExtension = (name?: string | null): string => {
  if (!name) return "";
  const parts = name.split(".");
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : "";
};

const isImageFile = (name?: string | null): boolean => {
  const ext = getFileExtension(name);
  return ["jpg", "jpeg", "png", "gif", "webp", "svg", "avif"].includes(ext);
};

const Response = z.array(
  z.object({
    id: z.number(),
    document_id: z.number(),
    url: z.string(),
    thumbnail_url: z.string().nullable(),
    creator: z.number(),
    name: z.string().nullable(),
    size: z.number().nullable(),
    created_at: z.string().nullable(),
    insight_count: z.number().optional()
  })
);

const Request = z.void();

type ResponseType = z.infer<typeof Response>;

type RequestType = z.infer<typeof Request>;

export type MediaItem = ResponseType[number];

// type x = z.infer<ReturnType<typeof getResponseSchema>>;
export const useUnassignedFiles = createQuery<ResponseType, RequestType, Error>(
  {
    queryKey: ["unassignedFiles"],
    staleTime: 1000 * 60,
    fetcher: async (variables) => {
      const result = await api<RequestType, ResponseType>({
        method: "GET",
        url: `/file/unassigned/list`,
        requestSchema: Request,
        responseSchema: Response,
        body: variables
      });
      return result.filter((file) => file.name && isImageFile(file.name));
    }
  }
);

export const useUnassignedFilesWithSuspense = createSuspenseQuery<
  ResponseType,
  RequestType,
  Error
>({
  queryKey: ["unassignedFiles"],
  staleTime: 1000 * 60,
  fetcher: async (variables) => {
    // wait 2 seconds
    // await new Promise((resolve) => setTimeout(resolve, 200000));
    return api<RequestType, ResponseType>({
      method: "GET",
      url: `/file/unassigned/list`,
      requestSchema: Request,
      responseSchema: Response,
      body: variables
    });
  }
});
